import { Box } from '@mui/material';
import { SurveyCard } from './SurveyCard';
import { Survey } from './models/Survey';
import { useNavigate } from 'react-router-dom';

type SurveySectionProps = {
  surveys: Survey[];
};

const TOTAL_SURVEY_BACKGROUND = 5;

export const SurveyList = ({ surveys }: SurveySectionProps) => {
  const navigate = useNavigate();

  function handleOpenLink(survey: Survey) {
    navigate('/mybrightlink/survey', {
      state: {
        surveyLink: survey.surveyLink,
        type: survey.type,
      },
    });
  }

  return (
    <Box
      sx={{
        pt: 5,
        pb: 3,
        borderRadius: 4,
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 5,
        overflow: 'auto',
      }}
      className='hide-scrollbar'
    >
      {surveys.map((survey, idx) => {
        const backgroundIndex = (idx % TOTAL_SURVEY_BACKGROUND) + 1;
        const backgroundUrl = `/public/assets/images/csat_survey_background_${backgroundIndex}.png`;
        return (
          <SurveyCard
            key={survey.surveyLink}
            survey={survey}
            backgroundUrl={backgroundUrl}
            handleOpenLink={handleOpenLink}
          />
        );
      })}
    </Box>
  );
};
